<mibp-dialog [buttons]="dialogButtons" (buttonClick)="dialogClick($event)" [hideCloseButton]="false" size="narrow" [id]="'add-to-cart-dialog'">
  <div class="dialog-container">
    <div class="dialog-header">
      <h1 class="heading-type-2">
        <mibp-resource-string key="CartsDialog_Product_Added"></mibp-resource-string>
      </h1>
      <button class="my-icon-button close" type="button" (click)="closeDialog()">
        <span class="material-icon material-icon--xlarge">close</span>
      </button>
    </div>
    <h1 class="article-heading-3 error"><strong>{{errorText}}</strong></h1>
    <h1 class="article-heading-3 error">{{itemCodesText}}</h1>

    <div class="product-info">
      @for (product of firstTwoProducts; track product; let i = $index) {
        <div class="product">
          <div class="columns">
            <div class="column image-container">
              <a (click)="onClickProductImage(product.code)">
                @if (product.imageUrl) {
                  <mibp-image  [urlOfImage]="product.imageUrl"></mibp-image>
                }
                <!-- <img *ngIf="product.partsPictureImageUrl"  [src]="product.partsPictureImageUrl" [alt]="product.name"> -->
                @if (!product.imageUrl) {
                  <img  src="assets/images/NewDefaultImage.png" alt="image missing">
                }
              </a>
            </div>
            <div class = column>
              <a  (click)="onClickProductImage(product.code)">
                <h1 class="article-heading-h2">
                  <strong>
                    {{product.translatedName || product.name}}
                  </strong>
                </h1>
              </a>
              <h1>
                <span class="item-label"><mibp-resource-string key="Global_ProductNumber"></mibp-resource-string>: </span> {{product.code}}
              </h1>

              <ng-template 
                #priceStateContext="priceStateContext"
                [priceStateContextSource]="priceAndAvailabilitySource"
                [priceStateContext]="product.code"
                let-showPrice="showPrice">
                @if (showPrice && dialogOptionShowPrices) {
                  <tr class="prop prop--price">
                    <td><mibp-resource-string key="Global_UnitPrice"></mibp-resource-string></td>
                    <td>
                      <mibp-price-state [productCode]="product.code" [source]="priceAndAvailabilitySource" [isRestrictedByPrice]="false"></mibp-price-state>
                    </td>
                  </tr>
                }
              </ng-template>
            </div>
          </div>
        </div>
      }
      @if (additionalProducts > 0) {
        <p class="additionalProductsText">
          <mibp-resource-string key="CartsDialog_More_Products" [macros]="{count: additionalProducts.toString()}">
          </mibp-resource-string>
        </p>
      }

      @if (hasDuplicates) {
        <div [automatedTestId]="'dialog-cart-has-duplicate-products'" class="duplicate" >
          <span translate="no" class="material-icon material-icon--red material-icon--fill">error</span>
          <p>
            <mibp-resource-string key="CartsDialog_Duplicate_Products"></mibp-resource-string>
          </p>
        </div>
      }
    </div>

    @if (hasUpsell) {
      <div class="upsell-cross-sell-container">
        <mibp-upsell (closeDialogBox)="onCloseCrossSellUpsellDialog($event)" [setUpsellCrossSellProductId]="upsellProductId" (productHasBeenUpgradedEvent)="productHasBeenUpgradedByUpsell()"></mibp-upsell>
      </div>
    }

    @if (!hasUpsell && hasCrossSell) {
      <div class="upsell-cross-sell-container">
        <mibp-cross-sell (closeDialogBox)="onCloseCrossSellUpsellDialog($event)" [setCrossSellProductIds]="crossSellProductIds" (crossSellProductAddedToCartEvent)="onCrossSellProductAddedToCart()"></mibp-cross-sell>
      </div>
    }

  </div>
</mibp-dialog>
